import { Differentiation } from 'approot/shared/differentiation/differentiation.constants';

export function getDifferentiatedAssessmentTitle(
  differentiation: Differentiation | null
) {
  switch (differentiation) {
    case Differentiation.SelfAssessment:
      return 'Self-Assessment';
    case Differentiation.AnchorMap:
      return 'Anchor Map';
    case Differentiation.UnitQuiz:
      return 'Unit Quiz';
    default:
      return 'Assessment with Differentiation';
  }
}
